var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow_inline_svg__clip0_12571_5777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.753 18.001h0a.812.812 0 11.542-1.531 13.35 13.35 0 0016.97-7.937l1.131-.752.403 1.289A14.962 14.962 0 01.753 18zm19.415-11.8l-.1-.318-.277.185-4.717 3.138a.812.812 0 01-.9-1.353l5.896-3.922a.812.812 0 011.226.434l2.114 6.758a.814.814 0 01-.533 1.018l.075.239-.075-.239a.814.814 0 01-1.018-.533l-1.691-5.406z",
    fill: "#424242",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_inline_svg__clip0_12571_5777"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgArrowinline;